<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品设置-添加商品
  -->
    <div class="pb50">
        <el-form v-if="!loading" ref="form" size="small" :model="form" label-width="150px">
            <!--商品信息-->
            <Info></Info>

            <!--规格-->
            <Spec></Spec>

            <!--其它-->
            <Other></Other>

            <!--提交-->
        </el-form>

        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
        </div>
    </div>
</template>
<script>
    import SeckillApi from "@/api/seckill";
    import Info from "./part/Info.vue";
    import Spec from "./part/Spec.vue";
    import Other from "./part/Other.vue";
    import { formatModel } from "@/utils/base.js";
    export default {
        components: {
            /*产品基本信息*/
            Info,
            /*规格*/
            Spec,
            /*其它*/
            Other
        },
        provide: function() {
            return {
                form: this.form,
                type: "add"
            };
        },
        data() {
            return {
                /*是否正在加载*/
                loading: true,
                /*表单*/
                form: {
                    /*商品ID*/
                    seckill_goods_id: 0,
                    /*商品状态*/
                    status: 10,
                    /*商品名称*/
                    goods_name: "",
                    /*图片*/
                    goods_image: "",
                    /*排序*/
                    sort: 100,
                    /*规格*/
                    goods_sku_id: 0,
                    /*限购数量*/
                    limit_num: 1,
                    /*商品表格*/
                    tableData: [],
                    /*活动名称*/
                    active_name: ""
                }
            };
        },
        created() {
            this.form.seckill_goods_id = this.$route.query.seckill_goods_id;
            this.getData();
        },
        methods: {
            /*获取商品*/
            getData() {
                let self = this;
                SeckillApi.detailGoods(
                    {
                        seckill_goods_id: self.form.seckill_goods_id
                    },
                    true
                ).then((res) => {
                    self.form.goods_name = res.data.model.goods.goods_name;
                    self.form.goods_image = res.data.model.goods.image[0].file_path;
                    self.form.goods_id = res.data.model.goods.goods_id;
                    self.form.limit_num = res.data.model.limit_num;
                    self.form.stock = res.data.model.stock;
                    self.form.active_name = res.data.model.active.title;
                    res.data.model.seckillSku.forEach((item) => {
                        item.goods_name = self.form.goods_name;
                        item.spec_name = item.goods_attr;
                        item.spec_type = res.data.model.goods.spec_type;
                    });
                    self.form.tableData = res.data.model.seckillSku;
                    self.loading = false;
                });
            },

            /*提交表单*/
            onSubmit() {
                let self = this;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = {
                            goods: {}
                        };
                        params.goods_id = self.form.goods_id;
                        params.status = self.form.status;
                        params.sort = self.form.sort;
                        params.limit_num = self.form.limit_num;
                        params.seckill_goods_id = self.form.seckill_goods_id;
                        params.goods_id = self.form.goods_id;
                        params.goods.spec_list = self.tableFormet(self.form.tableData);
                        self.loading = true;
                        SeckillApi.saveGoods(params, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: "恭喜你，修改成功",
                                    type: "success"
                                });
                                self.cancelFunc();
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*表格数据格式化*/
            tableFormet(list) {
                list.forEach((item) => {
                    item.goods_attr = item.spec_name;
                });
                return list;
            },

            /*取消*/
            cancelFunc() {
                this.$router.back(-1);
            }
        }
    };
</script>
<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity/seckill/edit.vue